module.exports = __webpack_public_path__ + "img/select-house.9128a0c6.svg";